import { useEffect } from "react"

export const useReadModelList = ({ id, readList, refresh }) => {
  useEffect(() => {
    if (id) {
      readList({ id })
    }
  }, [refresh, id])
}
